import { blogService } from '@/services/blog.service';
import { useQuery } from '@tanstack/react-query';


export const useGetAllBlogs = (pageNumber: number) => {
    const { data, isLoading, isError, error, refetch, isPending } = useQuery({
        queryKey: ['blog', pageNumber],
        queryFn: () => blogService.getAllBlogs(pageNumber),
    });
    return {
        blogs: data?.data ?? [],
        totalPages: data?.pageCount,
        isLoading,
        isError,
        error,
        refetch,
        isPending,
    };
};
